import { render } from "./Sidebar.vue?vue&type=template&id=08d3286e&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=08d3286e&lang=scss&scoped=true"
import "./Sidebar.vue?vue&type=style&index=1&id=08d3286e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08d3286e"]])

export default __exports__